export default "__VITE_ASSET__CbYj2a6B__"